import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router-dom";
import '../../../style/SalesMarketing.css';
import { CheckCircleRounded, CloseRounded } from "@mui/icons-material";

interface ProductCodeUpdateModalProps {
    open: boolean,
    setOpen: Function
}

const ProductCodeUpdateModal = ({ open, setOpen }: ProductCodeUpdateModalProps) => {
    const { t } = useTranslation(['salesmarketing', 'translation']);
    const navigate = useNavigate();

    return (
        <>
            <Dialog open={open} maxWidth={false}>
                <DialogTitle sx={{borderBottom:'0px'}}>
                    <Grid container item xs={12}>
                        <Grid item xs={1}>
                            <CheckCircleRounded color={"success"} />
                        </Grid>
                        <Grid item xs={10}>
                            <Typography color="primary" className="ModalTitle">
                                {t('salesmarketing:product.updateModal.successTitle')}
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton sx={{position: 'absolute', right: 16, top: 12,}} onClick={() => { setOpen(false) }}>
                                <CloseRounded />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className="ModalBody">
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <Grid item>
                        <Typography color={"primary"} variant={"body1"} style={{whiteSpace: "pre-line"}}>
                        {t('salesmarketing:product.updateModal.content')}
                        </Typography>
                    </Grid>
                </Grid>
                </DialogContent>
                <DialogActions className="ModalFooter">
                    <Grid container item xs={12}>
                        <Grid item xs={9} />
                        <Grid item xs={3}>
                            <Button fullWidth className="Button" color={"accent"} onClick={() => { navigate("/salesmarketing/productcodelist") }}>
                                {t('salesmarketing:product.buttons.close')}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ProductCodeUpdateModal;